import { Injectable } from '@angular/core';

function noop() {}

@Injectable()
export class AnalyticsService {
  public constructor() {}

  publish(eventParams: object) {
    try {
      ((window as any)['_trackAnalytics'] || noop)(eventParams);
    } catch (err) {
      console.log('error publishing analytics event', err);
    }
  }

  continueClicked(currentView: string, options: object) {
    this.publish({
      site_events: { continue_click: true },
      current_view: currentView,
      ...options
    });
  }

  optionSelected(optionName: string) {
    this.publish({
      site_events: { option_selected: true },
      option_value: optionName
    });
  }

  optionsSelected(options: object, currentPage: string) {
    this.publish({
      site_events: { options_selected: true },
      selected_options: options,
      completed_view: currentPage
    });
  }

  inputClicked(inputName: string) {
    this.publish({
      site_events: { input_click: true },
      input_name: inputName
    });
  }

  checkboxChecked(checkboxName: string) {
    this.publish({
      site_events: { checkbox_checked: true },
      checkbox_name: checkboxName
    });
  }

  modalViewed(modalName: string) {
    this.publish({
      site_events: { modal_view: true },
      modal_name: modalName
    });
  }

  modalExited(modalName: string) {
    this.publish({
      site_events: { modal_exit: true },
      modal_name: modalName
    });
  }

  confirmClicked() {
    this.publish({ site_events: { confirm_click: true }});
  }

  cannotFindProfileClicked() {
    this.publish({ site_events: { cannot_find_profile_click: true }});
  }

  purchaseCompleted(purchaseParams: object) {
    this.publish({
      site_events: { purchaseComplete: true },
      ...purchaseParams
    });
  }
}
